import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { Nickname as a } from "../../../../../components/Nickname/index.js";
import { useTranslation as d } from "../../../../../hooks/useTranslation/index.js";
import { Container as m, Avatar as s, Content as c } from "./style.js";
const p = ({
  authorImage: t,
  authorNickname: i,
  ...o
}) => {
  const { t: e } = d("common");
  return /* @__PURE__ */ n(m, { title: e("header-verified-author-title"), ...o, children: [
    /* @__PURE__ */ r(s, { src: t, alt: e("header-verified-author-alt") }),
    /* @__PURE__ */ r(c, { children: /* @__PURE__ */ r("strong", { children: /* @__PURE__ */ r(a, { isVerified: !0, children: i }) }) })
  ] });
};
export {
  p as HeaderVerifiedAuthor
};
